var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "71.000000pt",
    height: "106.000000pt",
    viewBox: "0 0 71.000000 106.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,106.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279 1037 c-101 -29 -181 -96 -225 -191 -61 -131 -36 -241 104 -456 89 -138 182 -250 207 -250 25 0 118 112 207 250 144 221 166 330 97 469 -54 107 -159 177 -281 186 -36 3 -82 -1 -109 -8z m157 -176 c104 -47 134 -177 62 -265 -73 -89 -193 -89 -266 0 -53 64 -53 152 0 220 26 32 91 64 133 64 17 0 48 -9 71 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 236 c-98 -31 -142 -83 -110 -131 38 -57 152 -89 321 -89 125 0 203 13 267 45 88 44 85 110 -6 153 -64 31 -109 37 -114 15 -2 -12 14 -22 56 -38 101 -36 107 -70 18 -103 -111 -42 -331 -42 -442 0 -89 33 -82 69 18 103 37 12 53 23 53 35 0 23 -12 25 -61 10z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerIcon);
export default __webpack_public_path__ + "static/media/markerIcon.ef74234b.svg";
export { ForwardRef as ReactComponent };